import http from '../http'
import * as types from '../mutation-types';

export const state = {
    status: '',
    members: null,
    list: null,
    member: null,
    pagination: {}
};

export const getters = {
    loadStatus: state => state.status,
    members: state => state.members,
    list: state => state.list,
    member: state => state.member,
    pagination: state => state.pagination,
};

export const mutations = {
    /** LOAD */
    [types.LOAD_MEMBERS_LOADING](state) {
        state.status = 'loading'
    },
    [types.LOAD_MEMBERS_SUCCESS](state, {data, meta}) {
        state.status = 'success'
        state.members = data
        state.pagination = meta.pagination
    },
    [types.LOAD_MEMBERS_ERROR](state) {
        state.status = 'error'
    },
    /** LIST */
    [types.LIST_MEMBERS_LOADING](state) {
        state.status = 'loading'
    },
    [types.LIST_MEMBERS_SUCCESS](state, {data}) {
        state.status = 'success'
        state.list = data
    },
    [types.LIST_MEMBERS_ERROR](state) {
        state.status = 'error'
    },
    /** STORE */
    [types.STORE_MEMBER_ERROR](state) {
        state.status = 'error';
    },
    [types.STORE_MEMBER_SUCCESS](state, {data}) {
        state.status = 'success';
        state.member = data
    },
    [types.STORE_MEMBER_LOADING](state) {
        state.status = 'loading';
    },
    /** UPDATE */
    [types.UPDATE_MEMBER_ERROR](state) {
        state.status = 'error';
    },
    [types.UPDATE_MEMBER_SUCCESS](state, {data}) {
        state.status = 'success';
        state.member = data
    },
    [types.UPDATE_MEMBER_LOADING](state) {
        state.status = 'loading';
    },
    /** DELETE */
    [types.DELETE_MEMBER_LOADING](state) {
        state.status = 'error';
    },
    [types.DELETE_MEMBER_SUCCESS](state, params) {
        state.status = 'success';
        const index = state.members.indexOf(params);
        state.members.splice(index, 1);
    },
    [types.DELETE_MEMBER_ERROR](state) {
        state.status = 'loading';
    },
};

export const actions = {
    load({commit}, params) {
        return new Promise((resolve, reject) => {
            commit(types.LOAD_MEMBERS_LOADING);

            let map = {
                page(value) {
                    return ['page', value];
                },
                sortBy(value) {
                    return ['orderBy', value[0]];
                },
                sortDesc(value) {
                    return ['sortedBy', value[0] ? 'desc' : 'asc'];
                },
                search(values) {
                    let params = Object.assign({}, values),
                        paramsArray;

                    if (params.birthday) {
                        params.birthday = params.birthday.replace((new Date(params.birthday).getFullYear()), '') + '-';
                    }

                    paramsArray = Object.values(params);

                    if (paramsArray.filter(Boolean).length > 1) {
                        return [
                            'search',
                            JSON.stringify(params).replace(',', ';')
                                .replace(/["}{]/g, '')
                        ];
                    } else {
                        paramsArray = paramsArray.filter(Boolean);
                        return paramsArray.length ? ['search', paramsArray[0]] : null;
                    }
                },
            };

            params = Object.fromEntries(
                Object.entries(params)
                    .map(([key, value]) => map[key] && (value.length || !isNaN(value) || Object.keys(value).length) ? map[key](value) : false)
                    .filter(Boolean)
            )

            if (!params.orderBy) {
                delete params.orderBy;
                delete params.sortedBy;
            }

            if (params.search) {
                params.searchFields = 'name:like;birthday:like;email:like;wedding_date:like';
            }

            const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
            http.get('members?' + queryString).then(({data}) => {
                commit(types.LOAD_MEMBERS_SUCCESS, data)
                resolve(data)
            }).catch(({response}) => {
                commit(types.LOAD_MEMBERS_ERROR)
                reject(response.data)
            })
        })
    },
    list({commit}) {
        return new Promise((resolve, reject) => {
            commit(types.LIST_MEMBERS_LOADING);
            http.get('members/list').then(({data}) => {
                commit(types.LIST_MEMBERS_SUCCESS, data)
                resolve(data)
            }).catch(({response}) => {
                commit(types.LIST_MEMBERS_ERROR)
                reject(response.data)
            })
        })
    },
    store({commit}, params) {
        return new Promise((resolve, reject) => {
            commit(types.STORE_MEMBER_LOADING);
            http.post('members', params).then(({data}) => {
                commit(types.STORE_MEMBER_SUCCESS, data)
                resolve(data)
            }).catch(({response}) => {
                commit(types.STORE_MEMBER_ERROR)
                reject(response.data)
            })
        })
    },
    update({commit}, params) {
        return new Promise((resolve, reject) => {
            commit(types.UPDATE_MEMBER_LOADING);
            http.put(`members/${params.id}`, params).then(({data}) => {
                commit(types.UPDATE_MEMBER_SUCCESS, data)
                resolve(data)
            }).catch(({response}) => {
                commit(types.UPDATE_MEMBER_ERROR)
                reject(response.data)
            })
        })
    },
    delete({commit}, params) {
        return new Promise((resolve, reject) => {
            commit(types.DELETE_MEMBER_LOADING);
            http.delete(`members/${params.id}`, params).then(({data}) => {
                commit(types.DELETE_MEMBER_SUCCESS, params)
                resolve(data)
            }).catch(({response}) => {
                commit(types.DELETE_MEMBER_ERROR)
                reject(response.data)
            })
        })
    }
};
